var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('ProductionStatPage',{attrs:{"machine-list":_vm.machineList,"intervention-list1":_vm.interventionList1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }